module.exports = __webpack_public_path__ + "static/image18-59fdc8239a1091738c349a9d50243ddb.jpg";